import type { ReadonlyDeep } from 'type-fest';

import { ShareCapitalInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

export function shareCapitalForm2ApiMapper(
  shareCapital: ReadonlyDeep<ShareCapitalInput>,
): ReadonlyDeep<ShareCapitalInput> {
  return pruneInput(shareCapital, ShareCapitalInput);
}
